import { render, staticRenderFns } from "./QuestionReport.Label.vue?vue&type=template&id=eaea2848&"
import script from "./QuestionReport.Label.vue?vue&type=script&lang=js&"
export * from "./QuestionReport.Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports